import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  src: string;
}

export function SvgIconStyle({ src, sx }: Props): JSX.Element {
  return (
    <Box
      component="span"
      sx={{
        width: 24,
        height: 24,
        display: 'inline-block',
        bgcolor: 'currentColor',
        mask: `url("${src}") no-repeat center / contain`,
        WebkitMask: `url("${src}") no-repeat center / contain`,
        ...sx,
      }}
    />
  );
}
